import React from "react";
import {
  Button,
  Badge,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Check,
  X,
  ArrowCounterclockwise,
  ExclamationTriangleFill,
  LockFill,
} from "react-bootstrap-icons";
import { SubmitButton } from "../shared";

export function Actions({
  contract,
  unassigned,
  busy,
  errored,
  isApproveDisabled = false,
  approveDisabledReason,
  isDeclineDisabled = false,
  declineDisabledReason,
  onApprove,
  onDecline,
  onReset,
  canReset = true,
  resetBlockedReason,
}) {
  if (busy) {
    return (
      <div
        className="d-flex align-items-center justify-content-sm-end"
        style={{ minHeight: 31 }}
      >
        <Spinner
          animation="border"
          size="sm"
          className="text-secondary"
          role="status"
        >
          <span className="visually-hidden">Saving…</span>
        </Spinner>
      </div>
    );
  }

  if (contract.commissionStatus === "Approved") {
    return (
      <Resolved
        variant="success"
        label="Approved"
        onReset={onReset}
        canReset={canReset}
        resetBlockedReason={resetBlockedReason}
      />
    );
  }
  if (contract.commissionStatus === "Declined") {
    return (
      <Resolved
        variant="danger"
        label="Declined"
        onReset={onReset}
        canReset={canReset}
        resetBlockedReason={resetBlockedReason}
      />
    );
  }

  // pending
  return (
    <div className="d-flex align-items-center gap-2 justify-content-sm-end">
      {!unassigned && (
        <OverlayTrigger
          placement="top"
          popperConfig={{ strategy: "fixed" }}
          overlay={
            <Tooltip className="reset-lock-tooltip">
              {approveDisabledReason || "Cannot approve."}
            </Tooltip>
          }
          show={isApproveDisabled ? undefined : false}
        >
          <span
            className={`d-inline-flex align-items-center justify-content-center ${
              isApproveDisabled ? "reset-lock-indicator" : ""
            }`}
          >
            <SubmitButton
              text="Approve"
              color="green"
              onClick={onApprove}
              disabled={isApproveDisabled}
              icon={<Check size={16} />}
            />
          </span>
        </OverlayTrigger>
      )}
      <OverlayTrigger
        placement="top"
        popperConfig={{ strategy: "fixed" }}
        overlay={
          <Tooltip className="reset-lock-tooltip">
            {declineDisabledReason || "Cannot decline."}
          </Tooltip>
        }
        show={isDeclineDisabled ? undefined : false}
      >
        <span
          className={`d-inline-flex align-items-center justify-content-center ${
            isDeclineDisabled ? "reset-lock-indicator" : ""
          }`}
        >
          <Button
            variant="link"
            size="sm"
            onClick={onDecline}
            className="record-action-icon-btn"
            title="Decline"
            aria-label="Decline"
            disabled={isDeclineDisabled}
          >
            <X size={16} />
          </Button>
        </span>
      </OverlayTrigger>
    </div>
  );
}

function Resolved({ variant, label, onReset, canReset, resetBlockedReason }) {
  return (
    <div className="d-flex align-items-center gap-2 justify-content-sm-end">
      <Badge
        bg={`${variant}-subtle`}
        text={`${variant}`}
        className="px-3 py-2 fw-medium"
      >
        {label}
      </Badge>
      {canReset && onReset && (
        <Button
          variant="light"
          size="sm"
          onClick={onReset}
          title="Reset"
          className="d-inline-flex align-items-center justify-content-center text-secondary border-0"
          style={{ width: 32, height: 32, padding: 0 }}
        >
          <ArrowCounterclockwise size={16} />
        </Button>
      )}
      {!canReset && (
        <OverlayTrigger
          placement="top"
          popperConfig={{ strategy: "fixed" }}
          overlay={
            <Tooltip className="reset-lock-tooltip">
              {resetBlockedReason ||
                "Part of a payout run and cannot be reset."}
            </Tooltip>
          }
        >
          <span
            className="text-muted d-inline-flex align-items-center justify-content-center reset-lock-indicator"
            role="img"
            aria-label={
              resetBlockedReason || "Part of a payout run and cannot be reset."
            }
            style={{ width: 32, height: 32 }}
          >
            <LockFill size={14} />
          </span>
        </OverlayTrigger>
      )}
    </div>
  );
}
